import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Main from '../components/pages/Main';
import SwitchAccountant from '../components/pages/SwitchAccountant';

const TrocarContador = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Main removeFooter={isMobile} page="trocar-contador">
      <SwitchAccountant />
    </Main>
  );
};

export default TrocarContador;
